// import { Box, useTheme, useMediaQuery } from "@mui/material";
// import React, { useState, useEffect } from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   ResponsiveContainer,
//   Cell,
//   CartesianGrid,
//   Tooltip,
// } from "recharts";

// const FeatureUsageAnalytics = () => {
//   const [selectedMonth, setSelectedMonth] = useState("January");
//   const [flowStatsData, setFlowStatsData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const theme = useTheme();

//   // MUI breakpoints
//   const isXs = useMediaQuery(theme.breakpoints.down("sm")); // xs: 0-599px
//   const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // sm: 600-959px
//   const isMd = useMediaQuery(theme.breakpoints.between("md", "lg")); // md: 960-1279px
//   const isXl = useMediaQuery(theme.breakpoints.between("lg", "xl"));

//   // Get API base URL from environment variable
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   // Fetch flow stats data
//   useEffect(() => {
//     const fetchFlowStats = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE_URL}/super-admin/flow-stats`);

//         if (!response.ok) {
//           throw new Error("Failed to fetch flow stats");
//         }

//         const result = await response.json();

//         if (result.success) {
//           // Transform API data to chart format
//           const chartData = [
//             { name: "Post a Job", usage: result.data.flow1Count },
//             { name: "Import Candidates", usage: result.data.flow2Count },
//             { name: "Conduct Assessment", usage: result.data.flow3Count },
//             {
//               name: "Build Recruitment Pipeline",
//               usage: result.data.flow4Count,
//             },
//           ];

//           setFlowStatsData(chartData);
//         } else {
//           throw new Error(result.message || "Failed to fetch data");
//         }
//       } catch (err) {
//         setError(err.message);
//         console.error("Error fetching flow stats:", err);

//         // Fallback to default data in case of error
//         setFlowStatsData([
//           { name: "Post a Job", usage: 0 },
//           { name: "Import Candidates", usage: 0 },
//           { name: "Conduct Assessment", usage: 0 },
//           { name: "Build Recruitment Pipeline", usage: 0 },
//         ]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchFlowStats();
//   }, [API_BASE_URL]);

//   const featureCards = [
//     { rank: "#1 Feature", name: "Search", usage: "2,400" },
//     { rank: "#2 Feature", name: "Filter", usage: "1,800" },
//     { rank: "#3 Feature", name: "Analytics", usage: "1,200" },
//     { rank: "#4 Feature", name: "Reports", usage: "950" },
//     { rank: "#5 Feature", name: "Export", usage: "750" },
//     { rank: "#6 Feature", name: "Settings", usage: "600" },
//     { rank: "#7 Feature", name: "Help", usage: "450" },
//     { rank: "#8 Feature", name: "Profile", usage: "300" },
//     { rank: "#9 Feature", name: "Logout", usage: "150" },
//   ];

//   const handleMonthChange = (event) => {
//     setSelectedMonth(event.target.value);
//   };

//   // Calculate max value for Y-axis domain
//   const getMaxUsage = () => {
//     if (flowStatsData.length === 0) return 1200;
//     const maxValue = Math.max(...flowStatsData.map((item) => item.usage));
//     return Math.ceil(maxValue / 100) * 100; // Round up to nearest 100
//   };

//   // Responsive styles
//   const getResponsiveStyles = () => {
//     return {
//       container: {
//         backgroundColor: "#fff",
//         padding: isXs ? "16px" : isSm ? "24px" : "32px",
//         fontFamily: "Outfit",
//         marginLeft: isXs ? "0" : isSm ? "0" : isMd ? "120px" : "230px",
//       },
//       header: {
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         marginBottom: isXs ? "24px" : isSm ? "28px" : "32px",
//         flexDirection: isXs || isSm ? "column" : "row",
//         alignItems: isXs || isSm ? "flex-start" : "center",
//         gap: isXs || isSm ? "16px" : "0",
//       },
//       headerLeft: {
//         display: "flex",
//         flexDirection: "column",
//       },
//       title: {
//         fontSize: isXs ? "16px" : isSm ? "16px" : "18px",
//         fontWeight: "700",
//         fontFamily: "Outfit",
//         color: "#2B3674",
//         margin: "0 0 4px 0",
//         textAlign: "left",
//       },
//       subtitle: {
//         fontSize: isXs ? "14px" : "15px",
//         color: "#A3AED0",
//         fontWeight: "400",
//         fontFamily: "Outfit",
//         margin: "0",
//       },
//       selectContainer: {
//         position: "relative",
//         marginRight: ".7%",
//       },
//       select: {
//         appearance: "none",
//         backgroundColor: "white",
//         border: "1px solid #fff",
//         fontFamily: "Outfit",
//         fontWeight: 400,
//         borderRadius: "6px",
//         padding: isXs ? "6px 28px 6px 12px" : "8px 32px 8px 16px",
//         fontSize: isXs ? "15px" : "16px",
//         color: "#A3AED0",
//         outline: "none",
//         cursor: "pointer",
//       },
//       selectArrow: {
//         position: "absolute",
//         right: "8px",
//         top: "50%",
//         transform: "translateY(-50%)",
//         pointerEvents: "none",
//         color: "#9ca3af",
//       },
//       mainContent: {
//         display: "grid",
//         gridTemplateColumns: isXs || isSm || isMd ? "1fr" : "1fr 1fr",
//         gap: isXs ? "16px" : isSm ? "24px" : isMd ? "24px" : "32px",
//         height: isXs || isSm || isMd ? "auto" : "400px",
//         width: "100%",
//       },
//       chartSection: {
//         backgroundColor: "white",
//         borderRadius: "8px",
//         height: isXs ? "300px" : isSm ? "350px" : isMd ? "400px" : "100%",
//         width: "100%",
//         marginLeft: isXl ? "0%" : "-10%",
//         overflow: "hidden",
//         position: "relative",
//       },
//       chartContainer: {
//         padding: isXs
//           ? "16px 16px 8px 16px"
//           : isSm
//           ? "20px 20px 8px 20px"
//           : "24px 24px 8px 24px",
//         height: "100%",
//         // Removed filter: "blur(3px)" to show actual data
//       },
//       chartWrapper: {
//         position: "relative",
//         height: "100%",
//       },
//       yAxisLabel: {
//         position: "absolute",
//         left: "1px",
//         top: "50%",
//         transform: "rotate(-90deg) translateY(-50%)",
//         transformOrigin: "center",
//         fontSize: "12px",
//         color: "#6b7280",
//         fontWeight: "500",
//         whiteSpace: "nowrap",
//       },
//       chartInner: {
//         marginLeft: "24px",
//         height: "100%",
//       },
//       loadingContainer: {
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "rgba(255, 255, 255, 0.9)",
//         borderRadius: "8px",
//         zIndex: 10,
//       },
//       loadingText: {
//         fontSize: "16px",
//         color: "#2B3674",
//         fontFamily: "Outfit",
//       },
//       errorContainer: {
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "rgba(255, 255, 255, 0.9)",
//         borderRadius: "8px",
//         zIndex: 10,
//         padding: "20px",
//       },
//       errorText: {
//         fontSize: "14px",
//         color: "#dc2626",
//         fontFamily: "Outfit",
//         textAlign: "center",
//         marginBottom: "10px",
//       },
//       retryButton: {
//         padding: "8px 16px",
//         backgroundColor: "#0891b2",
//         color: "white",
//         border: "none",
//         borderRadius: "6px",
//         cursor: "pointer",
//         fontSize: "14px",
//         fontFamily: "Outfit",
//       },
//       cardsSection: {
//         height: "100%",
//         width: "100%",
//         marginLeft: isXl ? "0%" : "-2%",
//         position: "relative",
//       },
//       cardsGrid: {
//         display: "grid",
//         gridTemplateColumns: isXs ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
//         gap: isXs ? "8px" : isSm ? "10px" : "12px",
//         height: isXs || isSm || isMd ? "auto" : "100%",
//         width: "100%",
//         filter: "blur(3px)", // Keep blur for cards section
//       },
//       card: {
//         backgroundColor: "white",
//         border: "1px solid #e5e7eb",
//         borderRadius: "8px",
//         padding: isXs ? "8px" : isSm ? "10px" : "12px",
//         boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//       },
//       cardRank: {
//         fontSize: "13px",
//         margin: "0 0 8px 0",
//         fontWeight: "500",
//         textAlign: "left",
//         color: "#111827",
//         fontFamily: "Outfit",
//       },
//       cardName: {
//         fontSize: isXs ? "13px" : "14px",
//         fontWeight: "600",
//         color: "#111827",
//         margin: "0 0 8px 0",
//         textAlign: "left",
//         fontFamily: "Outfit",
//       },
//       cardUsage: {
//         fontSize: isXs ? "16px" : "18px",
//         fontWeight: "700",
//         color: "#0891b2",
//         margin: "0",
//         textAlign: "left",
//         fontFamily: "Outfit",
//       },
//       comingSoonOverlay: {
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "rgba(255, 255, 255, 0.7)",
//         borderRadius: "8px",
//         zIndex: 10,
//       },
//       comingSoonText: {
//         margin: "0",
//         fontSize: isXs ? "20px" : isSm ? "24px" : "28px",
//         fontWeight: "700",
//         color: "#2B3674",
//         fontFamily: "Outfit",
//         textAlign: "center",
//         textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//       },
//     };
//   };

//   const styles = getResponsiveStyles();

//   const retryFetch = () => {
//     setError(null);
//     // Re-trigger useEffect by changing a dependency or call fetchFlowStats directly
//     window.location.reload(); // Simple solution, you can implement a more elegant retry mechanism
//   };

//   // Custom tooltip component
//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       // Get the flow name from payload if label is not working
//       const flowName = payload[0]?.payload?.name || label || "Flow";
//       const usageCount = payload[0]?.value || 0;

//       return (
//         <div
//           style={{
//             backgroundColor: "#fff",
//             border: "1px solid #e5e7eb",
//             borderRadius: "8px",
//             padding: "12px 16px",
//             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
//             fontSize: "14px",
//             fontFamily: "Outfit",
//             color: "#2B3674",
//           }}
//         >
//           {/* Flow Name */}
//           {/* Usage Count */}
//           <p style={{ margin: "0", color: "#0891b2", fontWeight: "700" }}>
//             {`${usageCount} registrations`}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <Box sx={styles.container}>
//       {/* Header */}
//       <Box sx={styles.header}>
//         <Box sx={styles.headerLeft}>
//           <h1 style={styles.title}>Feature Usage Analytics</h1>
//           <p style={styles.subtitle}>Most frequently used platform features</p>
//         </Box>
//         <Box sx={styles.selectContainer}>
//           <select
//             value={selectedMonth}
//             onChange={handleMonthChange}
//             style={styles.select}
//           >
//             <option value="January">Month : January</option>
//             <option value="February">Month : February</option>
//             <option value="March">Month : March</option>
//           </select>
//           <Box sx={styles.selectArrow}>
//             <svg
//               width="16"
//               height="16"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M19 9l-7 7-7-7"
//               />
//             </svg>
//           </Box>
//         </Box>
//       </Box>

//       {/* Main Content */}
//       <Box sx={styles.mainContent}>
//         {/* Chart Section */}
//         <Box sx={styles.chartSection}>
//           <Box sx={styles.chartContainer}>
//             <Box sx={styles.chartWrapper}>
//               {/* Y-axis label */}
//               <Box sx={styles.yAxisLabel}>Usage count</Box>

//               {/* Chart container */}
//               <Box sx={styles.chartInner}>
//                 <ResponsiveContainer width="110%" height="100%">
//                   <BarChart
//                     data={flowStatsData}
//                     margin={{ top: 20, right: 30, left: 10, bottom: 60 }}
//                     barCategoryGap="35%"
//                   >
//                     <CartesianGrid
//                       strokeDasharray="0"
//                       stroke="#e2e8f0"
//                       strokeWidth={1}
//                       horizontal={true}
//                       vertical={false}
//                     />
//                     <XAxis
//                       dataKey="name"
//                       axisLine={false}
//                       tickLine={false}
//                       tick={{
//                         fontSize: 11,
//                         fill: "#64748b",
//                         fontWeight: "400",
//                       }}
//                       interval={0}
//                       height={60}
//                     />
//                     <YAxis
//                       axisLine={false}
//                       tickLine={false}
//                       tick={{
//                         fontSize: 11,
//                         fill: "#64748b",
//                         fontWeight: "400",
//                       }}
//                       domain={[0, getMaxUsage()]}
//                     />
//                     <Tooltip content={<CustomTooltip />} cursor={false} />
//                     <Bar dataKey="usage" radius={[6, 6, 0, 0]} fill="#0891b2">
//                       {flowStatsData.map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill="#0891b2" />
//                       ))}
//                     </Bar>
//                   </BarChart>
//                 </ResponsiveContainer>
//               </Box>
//             </Box>
//           </Box>

//           {/* Loading Overlay */}
//           {loading && (
//             <Box sx={styles.loadingContainer}>
//               <p style={styles.loadingText}>Loading chart data...</p>
//             </Box>
//           )}

//           {/* Error Overlay */}
//           {error && !loading && (
//             <Box sx={styles.errorContainer}>
//               <p style={styles.errorText}>Error loading data: {error}</p>
//               <button style={styles.retryButton} onClick={retryFetch}>
//                 Retry
//               </button>
//             </Box>
//           )}
//         </Box>

//         {/* Feature Cards Section */}
//         <Box sx={styles.cardsSection}>
//           <Box sx={styles.cardsGrid}>
//             {featureCards.map((feature, index) => (
//               <Box key={index} sx={styles.card}>
//                 <p style={styles.cardRank}>{feature.rank}</p>
//                 <h3 style={styles.cardName}>{feature.name}</h3>
//                 <p style={styles.cardUsage}>{feature.usage}</p>
//               </Box>
//             ))}
//           </Box>

//           {/* Coming Soon Overlay for Cards */}
//           <Box sx={styles.comingSoonOverlay}>
//             <h3 style={styles.comingSoonText}>Coming Soon</h3>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default FeatureUsageAnalytics;
import { Box, useTheme, useMediaQuery, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Cell,
  CartesianGrid,
  Tooltip,
} from "recharts";

const FeatureUsageAnalytics = ({ sidebarOpen = true }) => {
  // const [selectedMonth, setSelectedMonth] = useState("January");
  const [flowStatsData, setFlowStatsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const theme = useTheme();

  // MUI breakpoints
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // xs: 0-599px
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // sm: 600-959px
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg")); // md: 960-1279px
  const isXl = useMediaQuery(theme.breakpoints.between("lg", "xl"));

  // Get API base URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

  // Static feature cards for display (coming soon)
  const staticFeatureCards = [
    { rank: "#1 Feature", name: "Search", usage: "0" },
    { rank: "#2 Feature", name: "Filter", usage: "0" },
    { rank: "#3 Feature", name: "Analytics", usage: "0" },
    { rank: "#4 Feature", name: "Reports", usage: "0" },
    { rank: "#5 Feature", name: "Export", usage: "0" },
    { rank: "#6 Feature", name: "Settings", usage: "0" },
    { rank: "#7 Feature", name: "Help", usage: "0" },
    { rank: "#8 Feature", name: "Profile", usage: "0" },
    { rank: "#9 Feature", name: "Logout", usage: "0" },
  ];

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 206 : 110;

  // Fetch flow stats data
  useEffect(() => {
    const fetchFlowStats = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/super-admin/flow-stats`);

        if (!response.ok) {
          throw new Error("Failed to fetch flow stats");
        }

        const result = await response.json();

        if (result.success) {
          // Transform API data to chart format
          const chartData = [
            { name: "Post a Job", usage: result.data.flow1Count },
            { name: "Import Candidates", usage: result.data.flow2Count },
            { name: "Conduct Assessment", usage: result.data.flow3Count },
            {
              name: "Build Recruitment Pipeline",
              usage: result.data.flow4Count,
            },
          ];

          setFlowStatsData(chartData);
        } else {
          throw new Error(result.message || "Failed to fetch data");
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching flow stats:", err);

        // Fallback to default data in case of error
        setFlowStatsData([
          { name: "Post a Job", usage: 0 },
          { name: "Import Candidates", usage: 0 },
          { name: "Conduct Assessment", usage: 0 },
          { name: "Build Recruitment Pipeline", usage: 0 },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchFlowStats();
  }, [API_BASE_URL]);

  // const handleMonthChange = (event) => {
  //   setSelectedMonth(event.target.value);
  // };

  // Calculate max value for Y-axis domain
  const getMaxUsage = () => {
    if (flowStatsData.length === 0) return 1200;
    const maxValue = Math.max(...flowStatsData.map((item) => item.usage));
    return Math.ceil(maxValue / 100) * 100; // Round up to nearest 100
  };

  // Responsive styles
  const getResponsiveStyles = () => {
    return {
      container: {
        backgroundColor: "#fff",
        padding: isXs ? "16px" : isSm ? "24px" : "32px",
        fontFamily: "Outfit",
        marginLeft: {
          xs: "0px",
          sm: "0px",
          md: `${sidebarWidth}px`,
          xl: `${sidebarWidth}px`,
        },
        transition: "margin-left 0.3s ease",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: isXs ? "24px" : isSm ? "28px" : "32px",
        flexDirection: isXs || isSm ? "column" : "row",
        alignItems: isXs || isSm ? "flex-start" : "center",
        gap: isXs || isSm ? "16px" : "0",
      },
      headerLeft: {
        display: "flex",
        flexDirection: "column",
      },
      title: {
        fontSize: isXs ? "16px" : isSm ? "16px" : "18px",
        fontWeight: "700",
        fontFamily: "Outfit",
        color: "#2B3674",
        margin: "0 0 4px 0",
        textAlign: "left",
      },
      subtitle: {
        fontSize: isXs ? "14px" : "15px",
        color: "#A3AED0",
        fontWeight: "400",
        fontFamily: "Outfit",
        margin: "0",
      },
      selectContainer: {
        position: "relative",
        marginRight: ".7%",
      },
      select: {
        appearance: "none",
        backgroundColor: "white",
        border: "1px solid #fff",
        fontFamily: "Outfit",
        fontWeight: 400,
        borderRadius: "6px",
        padding: isXs ? "6px 28px 6px 12px" : "8px 32px 8px 16px",
        fontSize: isXs ? "15px" : "16px",
        color: "#A3AED0",
        outline: "none",
        cursor: "pointer",
      },
      selectArrow: {
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        pointerEvents: "none",
        color: "#9ca3af",
      },
      mainContent: {
        display: "grid",
        gridTemplateColumns: isXs || isSm || isMd ? "1fr" : "1fr 1fr",
        // eslint-disable-next-line no-undef
        gap: isXs ? "16px" : isMd ? "24px" : "32px",
        height: isXs || isSm || isMd ? "auto" : "400px",
        width: "100%",
      },
      chartSection: {
        backgroundColor: "white",
        borderRadius: "8px",
        height: isXs ? "300px" : isSm ? "350px" : isMd ? "400px" : "100%",
        width: "100%",
        marginLeft: isXl ? "0%" : "-10%",
        overflow: "hidden",
        position: "relative",
      },
      chartContainer: {
        padding: isXs
          ? "16px 16px 8px 16px"
          : isSm
          ? "20px 20px 8px 20px"
          : "24px 24px 8px 24px",
        height: "100%",
      },
      chartWrapper: {
        position: "relative",
        height: "100%",
      },
      yAxisLabel: {
        position: "absolute",
        left: "1px",
        top: "50%",
        transform: "rotate(-90deg) translateY(-50%)",
        transformOrigin: "center",
        fontSize: "12px",
        color: "#6b7280",
        fontWeight: "500",
        whiteSpace: "nowrap",
      },
      chartInner: {
        marginLeft: "24px",
        height: "100%",
      },
      loadingContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "8px",
        zIndex: 10,
      },
      loadingText: {
        fontSize: "16px",
        color: "#2B3674",
        fontStyle: "Outfit",
      },
      errorContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "8px",
        zIndex: 10,
        padding: "20px",
      },
      errorText: {
        fontSize: "14px",
        color: "#dc2626",
        fontFamily: "Outfit",
        textAlign: "center",
        marginBottom: "10px",
      },
      retryButton: {
        padding: "8px 16px",
        backgroundColor: "#0891b2",
        color: "white",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "Outfit",
      },
      cardsSection: {
        height: "100%",
        width: "100%",
        marginLeft: isXl ? "0%" : "-2%",
        position: "relative",
      },
      cardsGrid: {
        display: "grid",
        gridTemplateColumns: isXs ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
        gap: isXs ? "8px" : isSm ? "10px" : "12px",
        height: isXs || isSm || isMd ? "auto" : "100%",
        width: "100%",
        filter: "blur(3px)", // Always blurred for coming soon effect
      },
      card: {
        backgroundColor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: isXs ? "8px" : isSm ? "10px" : "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      },
      cardRank: {
        fontSize: "13px",
        margin: "0 0 8px 0",
        fontWeight: "500",
        textAlign: "left",
        color: "#111827",
        fontFamily: "Outfit",
      },
      cardName: {
        fontSize: isXs ? "13px" : "14px",
        fontWeight: "600",
        color: "#111827",
        margin: "0 0 8px 0",
        textAlign: "left",
        fontFamily: "Outfit",
      },
      cardUsage: {
        fontSize: isXs ? "16px" : "18px",
        fontWeight: "700",
        color: "#0891b2",
        margin: "0",
        textAlign: "left",
        fontFamily: "Outfit",
      },
      comingSoonOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        borderRadius: "8px",
        zIndex: 10,
      },
      comingSoonText: {
        margin: "0",
        fontSize: isXs ? "20px" : isSm ? "24px" : "28px",
        fontWeight: "700",
        color: "#2B3674",
        fontFamily: "Outfit",
        textAlign: "center",
        textShadow: "0 2px 4px rgba(0,0,0,0.1)",
      },
    };
  };

  const styles = getResponsiveStyles();

  const retryFetch = () => {
    setError(null);
    window.location.reload();
  };

  // Custom tooltip component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const flowName = payload[0]?.payload?.name || label || "Flow";
      const usageCount = payload[0]?.value || 0;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "12px 16px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            fontSize: "14px",
            fontFamily: "Outfit",
            color: "#2B3674",
          }}
        >
          <p style={{ margin: "0", color: "#0891b2", fontWeight: "700" }}>
            {`${usageCount}`}
          </p>
        </div>
      );
    }
    return null;
  };

  // Show error message with proper styling
  if (error) {
    return (
      <Box sx={styles.container}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontFamily: "Outfit", color: "red", fontSize: "16px" }}
          >
            Error: {error}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={styles.container}>
      {/* Header */}
      <Box sx={styles.header}>
        <Box sx={styles.headerLeft}>
          <h1 style={styles.title}>Feature Usage Analytics</h1>
          <p style={styles.subtitle}>Most frequently used platform features</p>
        </Box>
        {/* <Box sx={styles.selectContainer}>
          <select
            value={selectedMonth}
            onChange={handleMonthChange}
            style={styles.select}
          >
            <option value="January">Month : January</option>
            <option value="February">Month : February</option>
            <option value="March">Month : March</option>
          </select>
          <Box sx={styles.selectArrow}>
            <svg
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </Box>
        </Box> */}
      </Box>

      {/* Main Content */}
      <Box sx={styles.mainContent}>
        {/* Chart Section */}
        <Box sx={styles.chartSection}>
          <Box sx={styles.chartContainer}>
            <Box sx={styles.chartWrapper}>
              {/* Y-axis label */}
              <Box sx={styles.yAxisLabel}>Usage count</Box>

              {/* Chart container */}
              <Box sx={styles.chartInner}>
                <ResponsiveContainer width="110%" height="100%">
                  <BarChart
                    data={flowStatsData}
                    margin={{ top: 20, right: 30, left: 10, bottom: 60 }}
                    barCategoryGap="35%"
                  >
                    <CartesianGrid
                      strokeDasharray="0"
                      stroke="#e2e8f0"
                      strokeWidth={1}
                      horizontal={true}
                      vertical={false}
                    />
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      tick={{
                        fontSize: 11,
                        fill: "#64748b",
                        fontWeight: "400",
                      }}
                      interval={0}
                      height={60}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{
                        fontSize: 11,
                        fill: "#64748b",
                        fontWeight: "400",
                      }}
                      domain={[0, getMaxUsage()]}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={false} />
                    <Bar dataKey="usage" radius={[6, 6, 0, 0]} fill="#0891b2">
                      {flowStatsData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill="#0891b2" />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </Box>
          </Box>

          {/* Loading Overlay */}
          {loading && (
            <Box sx={styles.loadingContainer}>
              <p style={styles.loadingText}>Loading chart data...</p>
            </Box>
          )}

          {/* Error Overlay */}
          {error && !loading && (
            <Box sx={styles.errorContainer}>
              <p style={styles.errorText}>Error loading data: {error}</p>
              <button style={styles.retryButton} onClick={retryFetch}>
                Retry
              </button>
            </Box>
          )}
        </Box>

        {/* Feature Cards Section */}
        <Box sx={styles.cardsSection}>
          <Box sx={styles.cardsGrid}>
            {staticFeatureCards.map((feature, index) => (
              <Box key={index} sx={styles.card}>
                <p style={styles.cardRank}>{feature.rank}</p>
                <h3 style={styles.cardName}>{feature.name}</h3>
                <p style={styles.cardUsage}>{feature.usage}</p>
              </Box>
            ))}
          </Box>

          {/* Coming Soon Overlay */}
          <Box sx={styles.comingSoonOverlay}>
            <p style={styles.comingSoonText}>Coming Soon</p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FeatureUsageAnalytics;
